// create store / configure redux store

import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import storageSession from 'redux-persist/lib/storage/session';
import { createTransform, persistStore, persistReducer } from 'redux-persist';

import reducer from './../reducers';
import { getLocalizedResources, normalizeLocale } from '../resources';

// Runtime resources must always come from the current bundle/API response.
// Persisting them keeps values from an older deployment alive in sessionStorage.
const commonResourcesTransform = createTransform(
  (commonState) => {
    const { resources, resourcesByLocale, ...persistedCommonState } = commonState;
    return persistedCommonState;
  },
  (persistedCommonState) => ({
    ...persistedCommonState,
    resourcesByLocale: {},
    resources: getLocalizedResources(
      {},
      normalizeLocale(persistedCommonState.locale),
    ),
  }),
  { whitelist: ['common'] },
);

const persistConfig = {
  key: 'app',
  storage: storageSession,
  blacklist: ['loginData'],
  transforms: [commonResourcesTransform],
};

const persistedReducer = persistReducer(persistConfig, reducer);

const configureStore = () => {
  const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(thunk)));
  const persistor = persistStore(store);
  return {
    store,
    persistor,
  };
};

export default configureStore();
